import _ from "underscore";
import TreeNodeSet from "../../hierarchySelector/tree/TreeNodeSet";
import TwoLevelSelection from "../../controls/selectorControls/two_level_selection";
import {concatStr} from "../../atUtils";
import {saveArrayIntoCookies} from "../../atBrowserUtils";

export default function HierarchySelectorUtil() {

}

HierarchySelectorUtil.addNodesFromIdsArray = function( nodeIdsArray, treeNodeSet, rootNode, idPrefix )
{
    for( var i = 0; i < nodeIdsArray.length; i++ )
    {
        var treeNodeId = idPrefix ? HierarchySelectorUtil.makeTreeNodeId( idPrefix, nodeIdsArray[i] ) : nodeIdsArray[i];
        var treeNode = rootNode.getNodeById( treeNodeId );
        if( treeNode )
            treeNodeSet.add( treeNode );
    }
};

HierarchySelectorUtil.makeNodeSetByTwoLevelSelection = function(twoLevelSelection, rootNode, firstLevelIdPrefix, secondLevelIdPrefix) {
    var nodeSet = new TreeNodeSet();
    HierarchySelectorUtil.addNodesFromIdsArray( twoLevelSelection.getFirstLevel(), nodeSet, rootNode, firstLevelIdPrefix );
    HierarchySelectorUtil.addNodesFromIdsArray( twoLevelSelection.getSecondLevel(), nodeSet, rootNode, secondLevelIdPrefix );
    return nodeSet;
};

/**
 * Make id for tree node
 * @param prefix text presentation of type of a node
 * @param valueId id of node value
 */
HierarchySelectorUtil.makeTreeNodeId = function( prefix, valueId )
{
    return prefix + "_" + valueId;
};

HierarchySelectorUtil.isSelectionChanged = function(tree) {
    var selected = tree.getSelectionController().getSelectedNodeSet();
    var initiallySelected = tree.getSelectionController().getInitiallySelectedNodeSet();
    return !selected.equals(initiallySelected);
};

HierarchySelectorUtil.renderSimpleEntityName = function(renderer, treeNode, labelEl) {
    var entity = treeNode.getValue();
    labelEl.innerHTML = concatStr(renderer.selectorFilter.highlightTokens(entity.name), renderer.selectionHelper.getListDescriptionItemStatus(entity), " ");
    labelEl.title = renderer.getTitle(entity);
};

HierarchySelectorUtil.saveCollapsedNodesIntoCookies = function(tree, cookiesKey, nodeType) {
    var allNodes = tree.getExpandController().getCollapsedNodeSet().getAllNodes();
    var collapsedArray = [];
    _.each(allNodes, function(node)
    {
        if (node.getType() === nodeType)
            collapsedArray.push(node.getId());
    });
    saveArrayIntoCookies(collapsedArray, cookiesKey);
};

HierarchySelectorUtil.makeSelectionFromNodeSet = function(nodeSet, isFullFormed, nodeTypeResultLevelMapping, maxLevel) {
    var resultArrays = [[], []];
    var resultSet = {};

    for (var level = 1; level <= maxLevel; level++)
    {
        var levelMap = nodeSet.getLevelMap(level);
        _.each(_.values(levelMap), function(node)
        {
            var parent = node.getParent();
            while (parent)
            {
                if (resultSet[parent.getId()])
                    return;
                parent = parent.getParent();
            }

            var resultArrayIndex = nodeTypeResultLevelMapping[node.getType()];
            if (_.isNumber(resultArrayIndex))
            {
                var value = node.getValue();
                resultArrays[resultArrayIndex].push(isFullFormed ? value : value.id);
                resultSet[node.getId()] = true;
            }
        })
    }

    return new TwoLevelSelection(resultArrays[0], resultArrays[1]);
};

HierarchySelectorUtil.disableOrEnableSelector = function(button, selector, enabled, customText)
{
    button.setEnabled(enabled);
    if (!enabled)
    {
        button.setText(selector.getAllSelectedMessage());
    }
    else
    {
        if (selector.isAlreadyShown())
        {
            selector.fireChangeEvent();
        }
        else
        {
            button.setText( customText );
        }
    }
};

HierarchySelectorUtil.selectNodesParents = function(nodeSet, nodesLevel)
{
    let parentNodes = new TreeNodeSet()
    const nodes = Object.values(nodeSet.getLevelMap(nodesLevel))
    for (let node of nodes)
        parentNodes.add(node.getParent())

    let selectedParents = new TreeNodeSet()
    for (let parent of parentNodes.getAllNodes())
        if (nodeSet.containsAll(parent.getChildren()))
            selectedParents.add(parent)

    return selectedParents
};


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/hierarchy_selector_util.js